import { gql } from '@apollo/client';
import { apolloClient } from '../../apollo';

export const getInventoryQueryBuilder = (
	metrics,
	dimension,
	isTotal,
	isEditReplInstockPct,
	threshold
) => {
	const dimensionStr = `dimensions { 
        ${dimension} 
    }`;
	const dimensionQuery = isTotal ? `` : dimensionStr;

	const editReplInstockPct = `{
        attribute: "DIMENSION"
        name: "replenishableInstock"
        values: ["${threshold?.toString()}"]
    }`;

	const editReplInstockPctQuery = isEditReplInstockPct
		? editReplInstockPct
		: ``;

	return `federatedMetricValues(
                input: {
                    attributeFilters: [
                        {
                            attribute: "DIMENSION"
                            name: "${dimension}"
                            values: $ids
                        }
                        {
                            attribute: "DIMENSION"
                            name: "channel"
                            values: $channel
                        }
                        ${editReplInstockPctQuery}
                    ]
                    timeFilters: [
                        {
                            startDate: $startDate
                            endDate: $endDate
                        }
                    ]  
                }
            ) { 
                inventory {
                    edges {
                        node {
                            ${dimensionQuery}
                            metrics {
                                ${metrics.join(`
                                `)}
                            }
                        }
                    }
                }
            }`;
};

const getInventoryQuery = (metrics, dimension) => {
	const inventoryQueryBuilder = getInventoryQueryBuilder(metrics, dimension);
	const query = `query federatedMetricValues($startDate: String!, $endDate: String!, $ids: [String], $dimension: String!, $channel: [String]) {
            ${inventoryQueryBuilder}
        }`;
	return query;
};

export const getInventoryMetrics = (metrics, dimension, ids, payload) => {
	const obj = {
		...payload,
		ids: ids,
		dimension: dimension,
		channel: ['STORE'],
	};

	const query = gql`
		${getInventoryQuery(metrics, dimension, ids)}
	`;

	return apolloClient.query({
		query,
		context: {
			headers: {
				'x-Apollo-operation-name': 'federatedMetricValues',
			},
		},
		variables: obj,
	});
};
